<template>
  <div>
    <component :is="Header"></component>
    <component :is="SubHeader"></component>
    <router-view></router-view>
  </div>
</template>

<script>
import Header from '../components/Header.vue'
import SubHeader from '../components/SubHeader.vue'
import { dialogboxMixin } from '../components/Mixins/Dialogbox'

export default {
  data: function () {
    return {
      Header,
      SubHeader
    }
  },
  mixins: [dialogboxMixin],
  methods: {
    updateToolBarTitle (title) {
      if (title) this.$store.commit('subheader/UPDATE_TITLE', title)
    },

    async askForSave (from) {
      let saveOnQuitInfo = this.$store.getters['entry/getSaveOnQuit']
      if (saveOnQuitInfo && this.$store.getters['entry/getAskForSaveOnQuit']) {
        const rep = await this.msgbox({
          title: saveOnQuitInfo.title,
          content: saveOnQuitInfo.content,
          cancelAction: this.$t('dialog.user.update.cancelAction'),
          confirmAction: this.$t('dialog.user.update.confirmAction')
        })

        if (rep === 'confirm') {
          if (!await this.$store.dispatch('entry/ASK_FOR_SAVE')) throw new Error('error')
        } else {
          if (rep !== 'cancel') throw new Error('error')
          else this.$store.commit('entry/UPDATE_ASK_FOR_SAVE_ON_QUIT', false)
        }
      }
    }
  },

  beforeRouteEnter: function (to, from, next) {
    // This n'est pas encore connu
    next(vm => {
      // access to component instance via `vm`
      if (to && to.meta && to.meta.toolbar && to.meta.toolbar.title) vm.updateToolBarTitle(to.meta.toolbar.title)
    })
  },
  beforeRouteUpdate: async function (to, from, next) {
    try {
      await this.askForSave()
      if (to && to.meta && to.meta.toolbar && to.meta.toolbar.title) this.updateToolBarTitle(to.meta.toolbar.title)
      next()
    } catch (err) { }
  },
  beforeRouteLeave: async function (to, from, next) {
    try {
      await this.askForSave()
      next()
    } catch (err) { }
  }
}
</script>
